import * as React from "react";
import { connect } from "react-redux";
import {
	DropTarget,
	DragSource,
	DropTargetConnector,
	DragSourceConnector,
	DragSourceMonitor
} from "react-dnd";
import { WithStyles, Theme, createStyles, withStyles } from "@material-ui/core";
import { InjectedTranslateProps, translate } from "react-i18next";

import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import {
	sortableTarget,
	sortableSource,
	InjectedSortableProps
} from "../../dnd/sortable";
import { StoreState } from "../../reducers/root-reducer";
import { Area } from "../../api/areas";

interface State {
	areaName: string;
}

export interface TableItemProps {
	index: number;
	areaId: string;
	displayName: string;
	peopleSoftLimit: number;
	onEditClick: (index: number) => void;
	onDeleteClick: (index: number) => void;
}

interface ConnectedTableItemProps extends WithStyles<typeof styles> {
	areas: Area[];
}

type Props = TableItemProps &
	ConnectedTableItemProps &
	InjectedSortableProps &
	InjectedTranslateProps;

export class TableItem extends React.Component<Props, State> {
	public state: State = {
		areaName: ""
	};

	setAreaName = (props: Props) => {
		const { areas, areaId } = props;

		this.setState({
			areaName: areas.reduce((acc, area) => {
				if (area.id === areaId) {
					acc = area.name;
				}

				return acc;
			}, "")
		});
	};

	componentDidMount() {
		this.setAreaName(this.props);
	}

	componentWillReceiveProps(nextProps: Props) {
		if (this.props.areaId !== nextProps.areaId) {
			this.setAreaName(nextProps);
		}
	}

	render() {
		const {
			index,
			areaId,
			displayName,
			peopleSoftLimit,
			onEditClick,
			onDeleteClick,
			classes,
			isDragging,
			connectDragSource,
			connectDropTarget
		} = this.props;

		return (
			connectDragSource &&
			connectDropTarget &&
			connectDragSource(
				connectDropTarget(
					<div
						className={classes.root}
						style={{ opacity: isDragging ? 0 : 1 }}
					>
						<ListItem>
							<ListItemText
								primary={displayName}
								secondary={
									"Softlimit: " +
									peopleSoftLimit +
									" / Bereich: " +
									this.state.areaName
								}
							/>
							<ListItemSecondaryAction>
								<IconButton
									className={classes.editButton}
									onClick={() => onEditClick(index)}
								>
									<EditIcon />
								</IconButton>
								<IconButton
									className={classes.deleteButton}
									onClick={() => onDeleteClick(index)}
								>
									<DeleteIcon />
								</IconButton>
							</ListItemSecondaryAction>
						</ListItem>
					</div>
				)
			)
		);
	}
}

@DropTarget("Item", sortableTarget, (connect: DropTargetConnector) => ({
	connectDropTarget: connect.dropTarget()
}))
@DragSource(
	"Item",
	sortableSource,
	(connect: DragSourceConnector, monitor: DragSourceMonitor) => ({
		connectDragSource: connect.dragSource(),
		isDragging: monitor.isDragging()
	})
)
class DecoratedTableItem extends TableItem {}

const mapStateToProps = (state: StoreState) => ({
	areas: state.areas
});

const styles = (theme: Theme) =>
	createStyles({
		root: {
			cursor: "move"
		},
		editButton: {},
		deleteButton: {}
	});

export const ConnectedTableItem = translate("translations")(
	withStyles(styles)(connect(mapStateToProps)(DecoratedTableItem))
);
